import rejs1 from "./GRN_0093.webp";
import rejs2 from "./20240518_092429.webp";
import rejs3 from "./20240908_095405.webp";
import rejs4 from "./[Group 7].webp";
import rejs5 from "./20240922_093124.webp";
import rejs6 from "./Przystan czorsztyn dron_42.webp";
import rejs7 from "./cruise.webp";
import rejs8 from "./IMG_0263.webp";
import rejs9 from "./1.webp";
import rejs10 from "./20240709_144529.webp";
import rejs11 from "./Przystan czorsztyn dron_50.webp";
import rejs12 from "./IMG_0508.webp";

export const cruiseImages = [rejs1, rejs2, rejs3, rejs4, rejs5, rejs6, rejs7, rejs8, rejs9, rejs10, rejs11, rejs12];